import React from "react";
import { Route, BrowserRouter as Router, Routes} from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";

// Nav
import Footer from "./components/Footer";
import Header from "./components/Nav/Header/Header";

// Pages
import About from "./components/AboutPage/About";
import DoorStyle from "./components/DoorStylePage/DoorStyle";
import Shop from "./components/ShopPage/Shop";
import Cart from "./components/CartPage/Cart";
import Checkout from './components/CheckoutPage/Checkout';
import Gallery from './components/Gallery/Gallery';

// Home Page Components
// TODO: Make Home.js and move these components there
import BrowserRange from "./components/Home/BrowseRange";
import ContactForm from "./components/Home/ContactSection";
import DesignInspiration from "./components/Gallery/DesignInspiration";
import ProductsSection from "./components/Home/ProductsSection";
import HeroSection from "./components/Home/HeroSection";
import UnderConstruction from "./components/UnderConstruction";

export default function App() {
  const { isLoggedIn } = useAuth();

  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route
            path="/"
            element={
                <>
                  {/*<InDevelopmentText />*/}
                  <HeroSection />
                  <BrowserRange />
                  <ProductsSection />
                  {/*<DesignInspiration />*/}
                  <ContactForm />
                </>
            }
          />
          <Route path="/doorstyle" element={<DoorStyle />} />
          <Route path="/shop/:collection/:doorStyle/:color" element={<Shop />} />
          <Route path="/cart" element={<UnderConstruction />} />
          <Route path='/gallery' element={<UnderConstruction />} />
          {/*<Route path='/checkout' element={<Checkout />} />*/}
          <Route path='/about' element={<UnderConstruction />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

const LoggedInText = () => {
  const { account } = useAuth();

  return (
    <p>
      Hey, {account.username}! I'm happy to let you know: you are authenticated!
    </p>
  );
};

const LoggedOutText = () => (
  <p>Don't forget to start your backend server, then authenticate yourself.</p>
);

const InDevelopmentText = () => (
  <p>
    This website is still in development. Please check back later for more!
  </p>
);